import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { formatCartDateRangeLabel } from '../cartModalHelpers';
import css from './CartModalHeader.module.css';

const CartModalHeader = props => {
  const {
    itemsCount,
    bookingDates,
    timeZone,
    intl,
    onClose,
    hasOtherCartGroups = false,
    onViewAllOrders,
  } = props;

  // Shared with the per-date-group section headers in CartModal so the panel can
  // never disagree with itself - and it shifts the exclusive end date back to the
  // inclusive last rental day, which the previous inline formatter didn't (a Sat-Sun
  // rental rendered as "Sep 19 - Sep 21" here while the filter bar said Sep 19-20).
  const formatDateRange = () => formatCartDateRangeLabel(bookingDates, timeZone, intl);

  return (
    <div className={css.header}>
      <div className={css.headerRow}>
        <div className={css.headerContent}>
          <h2 className={css.title}>
            <FormattedMessage
              id="CartModal.title"
              values={{
                count: itemsCount,
                b: chunks => <b>{chunks}</b>,
              }}
              defaultMessage="Rental Cart {count, plural, one {<b># Item</b>} other {<b># Items</b>}}"
            />
          </h2>
          {formatDateRange() && (
            <div className={css.dateRange}>
              <i className="ri-calendar-line" />
              {formatDateRange()}
            </div>
          )}
        </div>
        <button
          className={css.closeBtn}
          onClick={onClose}
          aria-label={intl.formatMessage({ id: 'CartModal.backToStore' })}
          type="button"
        >
          <svg width="10" height="16" viewBox="0 0 10 16" fill="none" aria-hidden="true">
            <path d="M8.5 1.5L1.5 8L8.5 14.5" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      <div className={css.secondaryActions}>
        <button type="button" className={css.secondaryLink} onClick={onClose}>
          <i className="ri-arrow-left-s-line" aria-hidden="true" />
          <FormattedMessage id="CartModal.continueShopping" />
        </button>
        {/* Same "All orders" swap as CartDrawer's header (RAS-2501): opens the
            all-orders panel in place rather than navigating to CartPage. Hidden when
            this order is the only one in the cart - the panel would list nothing but
            what's already on screen. */}
        {hasOtherCartGroups && onViewAllOrders ? (
          <button type="button" className={css.secondaryLink} onClick={onViewAllOrders}>
            <i className="ri-arrow-left-s-line" aria-hidden="true" />
            <FormattedMessage id="CartModal.allOpenCarts" defaultMessage="All Open Carts" />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default CartModalHeader;
